<!-- Data Table (Material) -->
<div class="table-container">
  <div class="data-table-container table-responsive">
    <!-- Skeleton Loading State -->
    <div class="skeleton-table" *ngIf="loading">
      <table class="data-table compact-table">
        <thead>
          <tr>
            <th *ngFor="let header of displayHeaders">
              {{ header.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let _ of skeletonRows">
            <td *ngFor="let header of displayHeaders">
              <div class="skeleton-cell"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Actual Table -->
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="onMatSort($event)"
      class="data-table mat-elevation-z0 compact-table"
      *ngIf="!loading"
    >
      <!-- Dynamic Columns -->
      <ng-container
        *ngFor="let header of displayHeaders"
        [matColumnDef]="header.field"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="header.width"
          [style.min-width]="header.width"
          [class.sortable]="header.sortable"
          [attr.mat-sort-header]="header.sortable ? header.field : null"
          [matTooltip]="header.header"
          matTooltipClass="table-header-tooltip"
        >
          {{ header.header }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <!-- Serial Number Column -->
          <ng-container *ngIf="header.field === 'serialNumber'">
            {{ getSerialNumber(i) }}
          </ng-container>

          <!-- Custom Template -->
          <ng-container
            *ngIf="
              header.field !== 'serialNumber' && header.customTemplate;
              else defaultCell
            "
          >
            <ng-container
              *ngTemplateOutlet="
                header.customTemplate;
                context: {
                  $implicit: row,
                  field: header.field
                }
              "
            ></ng-container>
          </ng-container>

          <!-- Default Cell -->
          <ng-template #defaultCell>
            <ng-container *ngIf="header.field !== 'serialNumber'">
              {{ row[header.field] ?? "N/A" }}
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnFields"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumnFields"
        (click)="onRowClick(row)"
        [class.clickable-row]="rowClick.observers.length > 0"
      ></tr>
    </table>

    <!-- Empty State -->
    <div class="empty-cell" *ngIf="!loading && tableData.length === 0">
      <div class="empty-state">
        <mat-icon>inbox</mat-icon>
        <p>{{ emptyMessage }}</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div
    class="pagination-container"
    *ngIf="paginationConfig.showPagination && !loading && tableData.length > 0"
  >
    <app-pagination
      [totalItems]="paginationConfig.totalItems"
      [currentPage]="paginationConfig.currentPage"
      [itemsPerPage]="paginationConfig.itemsPerPage"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      (pageEvent)="onPageChange($event)"
    />
  </div>
</div>
